import { SetUserDefinedProperty } from './helpers';
import { OPTIONS_USER_DEFINED_PROPERTY } from './user-defined-property-keys';
import { MemoizedSelector } from '@ngrx/store';
import { FormControlSelectors } from '../../form-control';
import { SetSelector } from './set-selector';

export interface IOption<T = any> {
  value: T;
  display: string;
}

function isStringArray<SelectOptions extends IOption>(array: Array<string> | Array<SelectOptions>): array is Array<string> {
  return array.length && typeof array[0] === 'string';
}

function isNumberArray<SelectOptions extends IOption>(array: Array<number> | Array<SelectOptions>): array is Array<number> {
  return array.length && typeof array[0] === 'number';
}

export function Options<SelectOptions extends IOption = IOption>(...options: Array<any> | Array<SelectOptions>) {

  if (isStringArray(options)) {
    options = options.map(option => ({ value: option, display: option }))
  }

  if (isNumberArray(options)) {
    options = options.map(option => ({ value: option, display: option.toString() }))
  }

  return function(target: any, propertyKey) {
    SetUserDefinedProperty(target, propertyKey, OPTIONS_USER_DEFINED_PROPERTY, options);
  }

}

export function OptionsFromSelector<T>(selector: MemoizedSelector<any, Array<IOption<T>>>) {
  return SetSelector(FormControlSelectors.OPTIONS, selector);
}
